import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../../diccionarios/comisionesModulo';
import { AltaDeVendedoresService } from '../../services/alta-de-vendedores.service';
import { TipoDeVendedorService } from '../../services/tipo-de-vendedor.service';
import { IndicadoresVivosService } from 'src/app/aplicaciones-modulos/indicadores-vivos/services/indicadores-vivos.service';



@Component({
  selector: 'app-alta-de-vendedores',
  templateUrl: './alta-de-vendedores.component.html',
  styleUrls: ['./alta-de-vendedores.component.css']
})
export class AltaDeVendedoresComponent implements OnInit {

  tituloCard: string = 'Alta de Vendedores';
  tituloForm: string = 'Lista De Alta de Vendedores';

  formulario: FormGroup;
  formularioEstados: FormGroup;

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;
  textoBuscar: string;

  //componentes para apuntar a diccionario
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  textBoton: string;

  //para cargar con el grid
  listaVacia: boolean = true;
  loading: boolean = false;
  modulo: any = {};
  GUARDAR: string = 'guardar';

  cmbEstadosFiltro: any[] = [
    {
      clave: '',
      valor: 'TODOS'
    },
    {
      clave: '1',
      valor: 'ACTIVO'
    },
    {
      clave: '0',
      valor: 'INACTIVO'
    },
  ];

  cmbEstados: any[] = [
    {
      clave: 'ACTIVO',
      valor: 'ACTIVO'
    },
    {
      clave: 'INACTIVO',
      valor: 'INACTIVO'
    },
  ];

  cmbSiNo: any[] = [
    {
      clave: '1',
      valor: 'SI'
    },
    {
      clave: '0',
      valor: 'NO'
    },
  ];

  constructor(
    private fb: FormBuilder,
    private commonFormService: CommonFormService,
    private _utils: UtilsService,
    private _altaDeVendedor: AltaDeVendedoresService,
    private _tiposDeVendedores: TipoDeVendedorService,
    private _indicadores: IndicadoresVivosService,

  ) { }

  ngOnInit() {
    this.modulo = comisionesModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;

    this.formulario = this.fb.group({
      idVendedor: ['', null],
      codigoSap: ['', [Validators.required]],
      cedula: ['', [Validators.required, Validators.maxLength(10)]],
      nombreVendedor1: ['', [Validators.required]],
      oficinaVenta: ['', []],
      centro: ['', []],
      unidadNegocio: ['', []],
      tipoVendedorId: ['', []],
      descripcion: ['', []],
      sueldoVariable: ['', [Validators.required]],
      excepcionSueldo: [false, []],
      fechaRegistro: ['', []],
      estado: ['', [Validators.required]],
      cargoNominal: ['', []],
      comisionaPorPersonal: [false, []],
      codigoVacacionista: ['', []],
      tipoVehiculo: ['', [Validators.maxLength(50)]],
    });

    this.formularioEstados = this.fb.group({
      estado: ['', [Validators.required]],
    });

    this.cargarGridcomponent();
    this.getTodo();
    this.tiposDeVendedores();

    this.formulario.get('estado').valueChanges
      .subscribe((resp) => {
        this.getFormValidationErrors();
      });

    this.formulario.get('excepcionSueldo').valueChanges
      .subscribe((resp) => {
        console.log("excepcionSueldo", this.formulario.get('excepcionSueldo').value);
        if (this.formulario.get('excepcionSueldo').value)
          this.formulario.get('sueldoVariable').enable();
        else {
          this.formulario.get('sueldoVariable').disable();
          this.setSueldoVariable();
        }
      });

    this.formulario.get('comisionaPorPersonal').valueChanges
      .subscribe((resp) => {
        console.log("excepcionSueldo", this.formulario.get('excepcionSueldo').value);
        if (this.formulario.get('comisionaPorPersonal').value)
          this.comisionaPorPersonal = true;
        else
          this.comisionaPorPersonal = false;
      });

    this.formulario.get('tipoVendedorId').valueChanges
      .subscribe((resp) => {
        console.log("this.tipoVendedorId", this.formulario.get('tipoVendedorId').value)
        console.log("resp", resp)
        if (resp > 0 && resp != null) {
          let index = this.listTiposDeVendedores.findIndex(e => e.idTipo == resp);
          if (index >= 0) {
            console.log("index", index)
            console.log("this.listTiposDeVendedores[index]", this.listTiposDeVendedores[index])
            this.formulario.get('sueldoVariable').setValue(this.listTiposDeVendedores[index].sueldoVariable);
            // this.formulario.patchValue({ sueldoVariable: this.listTiposDeVendedores[index].sueldoVariable });
          }
        }
      });

      this.formularioEstados.get('estado').valueChanges
      .subscribe((resp) => {
        this.loading = true;
        this._altaDeVendedor.getPorEstado(resp).subscribe((res: any[]) => {
          console.log("getTodoPorEstado()", res)
          this.loading = false;
          this.listaVacia = (res.length === 0) ? true : false;
          this.rowData = res;
        }, (err) => {
          this.loading = false;
          this.listaVacia = true;
          this.rowData = [];
        });
      });

    this.formularioEstados.get('estado').setValue('1');

  }

  /* FUNCIONES */
  setSueldoVariable() {
    let resp = this.formulario.get('tipoVendedorId').value;
    if (resp > 0 && resp != null) {
      let index = this.listTiposDeVendedores.findIndex(e => e.idTipo == resp);
      if (index >= 0) {
        console.log("index", index)
        console.log("this.listTiposDeVendedores[index]", this.listTiposDeVendedores[index])
        this.formulario.get('sueldoVariable').setValue(this.listTiposDeVendedores[index].sueldoVariable);
        // this.formulario.patchValue({ sueldoVariable: this.listTiposDeVendedores[index].sueldoVariable });
      }
      else
        this.formulario.get('sueldoVariable').setValue(0);
    }
  }

  listTiposDeVendedores;
  tiposDeVendedores() {
    this.loading = true;
    this._tiposDeVendedores.getTiposDeVendedores().subscribe((res: any[]) => {
      console.log("tiposDeVendedores()", res)
      this.loading = false;
      this.listTiposDeVendedores = res;
    }, (err) => {
      this.loading = false;
      this.listTiposDeVendedores = [];
    });
  }

  cargarGridcomponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'idVendedor',
        filter: true,
        sortable: true,
        width: 70,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Código SAP',
        field: 'codigoSap',
        sortable: true,
        width: 120,
        resizable: true,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Cédula',
        field: 'cedula',
        sortable: true,
        width: 120,
        resizable: true,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Nombres',
        field: 'nombreVendedor1',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Tipo Vendedor',
        field: 'descripcion',
        sortable: true,
        resizable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Oficina Venta',
        field: 'oficinaVenta',
        sortable: true,
        width: 120,
        resizable: true,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Centro',
        field: 'centro',
        sortable: true,
        width: 100,
        resizable: true,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Unidad de Negocio',
        field: 'unidadNegocio',
        sortable: true,
        resizable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Sueldo Variable',
        field: 'sueldoVariable',
        sortable: true,
        resizable: true,
        width: 100,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Excepción de Sueldo',
        field: 'excepcionSueldo',
        sortable: true,
        resizable: true,
        width: 100,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.warning
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    //params.api.sizeColumnsToFit();

  }

  nuevo() {
    this.comisionaPorPersonal = false;
    this.formulario.reset();
    this.formulario.get('excepcionSueldo').setValue(false);
    this.formulario.get('comisionaPorPersonal').setValue(false);
    this.formulario.get('sueldoVariable').disable();
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.textBoton = this.DAT_BTNS.guardar;
    this.tituloForm = 'Guardar Alta de Vendedor al Programa de Comisiones';
  }

  comisionaPorPersonal = false;
  editar({ rowData }) {
    console.log("editar", rowData)
    this.formulario.reset();
    rowData.cargoNominal = "";
    this.formulario.setValue(rowData);
    this.formulario.get("sueldoVariable").setValue(rowData.excepcionSueldo > 0 ? rowData.excepcionSueldo : rowData.sueldoVariable)
    this.formulario.get("comisionaPorPersonal").setValue(rowData.comisionaPorPersonal == "SI" ? 1 : 0);
    this.comisionaPorPersonal = rowData.comisionaPorPersonal == "SI" ? true : false;
    this.getVendedor("");
    document.getElementById('buttonAbrirModal').click();
  }

  acciones(event) {
    // debugger
    if (event === this.GUARDAR) {
      this.guardar();
    } else {
      this.limpiarRegresar();
    }
  }

  limpiarRegresar() {
    this.mostrarFormulario = false;
    this.tituloCard = 'Mantenedor Alta de Vendedores al Programa de Comisiones';
    this.tituloForm = 'Lista De Alta de Vendedores al Programa de Comisiones';
  }

  /** SERVICIOS */
  getTodo() {
    this.listaVacia = true;
    this.loading = true;

    this._altaDeVendedor.getTodo().subscribe((res: any[]) => {
      console.log("getTodo()", res)
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
      this.rowData = res;
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowData = [];
    });
  }

  eliminar({ rowData }) {
    console.log("eliminar", rowData)
    this._utils
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        // text: `${rowData.idValorFlete}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this._altaDeVendedor.delete(rowData.idVendedor),
      })
      .then((res: any) => {
        this.getTodo();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });

  }

  guardar() {

    let datos = this.formulario.getRawValue();
    datos.excepcionSueldo = this.formulario.get('excepcionSueldo').value ? 1 : 0;
    datos.comisionaPorPersonal = this.formulario.get('comisionaPorPersonal').value ? 1 : 0;

    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: '',
        action: this.DAT_BTNS.guardar,
        funcion: this._altaDeVendedor.save(datos),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarRegresar();
      this.formulario.reset();
      this.getTodo();
    }).catch((err) => {
      console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  actualizar() {
    console.log("actualizar");

    let datos = this.formulario.getRawValue();
    datos.excepcionSueldo = this.formulario.get('excepcionSueldo').value ? 1 : 0;
    datos.comisionaPorPersonal = this.formulario.get('comisionaPorPersonal').value ? 1 : 0;

    console.log(this.formulario.getRawValue())
    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._altaDeVendedor.update(datos),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.formulario.reset();
      this.getTodo();
      document.getElementById('cerrarModal').click();
    }).catch((err) => {
      console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }

  getVendedor(event) {
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;
    if (this.formulario.get("cedula").value != null && this.formulario.get("cedula").value.length > 0) {
      this._altaDeVendedor.getVendedorPorCedula(this.formulario.get("cedula").value).subscribe(
        (resp) => {
          if (resp) {
            this.formulario.controls['nombreVendedor1'].setValue(resp[0].nombres);
            this.formulario.controls['codigoSap'].setValue(resp[0].codigoSap);
            this.formulario.controls['cargoNominal'].setValue(resp[0].dscaCargo);
          } else {
            this.formulario.controls['nombreVendedor1'].setValue('');
            this.formulario.controls['codigoSap'].setValue('');
            this.formulario.controls['cargoNominal'].setValue('');
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.formulario.controls['nombreVendedor1'].setValue('');
          this.formulario.controls['codigoSap'].setValue('');
          this.formulario.controls['cargoNominal'].setValue('');
        }
      );
    }
  }

  getVendedor2() {
    this.loading = true;
    if (this.formulario.get("cedula").value != null && this.formulario.get("cedula").value.length > 0) {
      this._altaDeVendedor.getVendedorPorCedula(this.formulario.get("cedula").value).subscribe(
        (resp) => {
          if (resp) {
            this.formulario.controls['nombreVendedor1'].setValue(resp[0].nombres);
            this.formulario.controls['codigoSap'].setValue(resp[0].codigoSap);
            this.formulario.controls['cargoNominal'].setValue(resp[0].dscaCargo);
          } else {
            this.formulario.controls['nombreVendedor1'].setValue('');
            this.formulario.controls['codigoSap'].setValue('');
            this.formulario.controls['cargoNominal'].setValue('');
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.formulario.controls['nombreVendedor1'].setValue('');
          this.formulario.controls['codigoSap'].setValue('');
          this.formulario.controls['cargoNominal'].setValue('');
        }
      );
    }
  }

}
